import http from '@/utils/request.js'

export const getInfo = () => {
  return http.request({ 
    url: '/getInfo',
    method: 'get'
  })
}